(function () {
  'use strict';

  function initGallery() {
    var list    = document.querySelector('.product__media-list');
    var wrapper = document.querySelector('.product__media-wrapper');
    if (!list || !wrapper) return;

    var items = Array.from(list.querySelectorAll('.product__media-item'));
    if (items.length < 2) return;

    /* Dot-Container */
    var dotsEl = document.createElement('div');
    dotsEl.className = 'fifteen-gallery-dots';

    var dots = items.map(function (_, i) {
      var dot = document.createElement('span');
      dot.className = 'fifteen-gallery-dot' + (i === 0 ? ' is-active' : '');
      dot.addEventListener('click', function () {
        list.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' });
      });
      dotsEl.appendChild(dot);
      return dot;
    });

    wrapper.insertAdjacentElement('afterend', dotsEl);

    /* Scroll → Dot update */
    var cur = 0;
    list.addEventListener('scroll', function () {
      var idx = Math.round(list.scrollLeft / list.offsetWidth);
      idx = Math.max(0, Math.min(idx, items.length - 1));
      if (idx === cur) return;
      cur = idx;
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }, { passive: true });

    /* Variant change → reset to first image */
    document.addEventListener('variant:changed', function () {
      list.scrollTo({ left: 0, behavior: 'smooth' });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === 0); });
      cur = 0;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGallery);
  else initGallery();
})();
